import { render, staticRenderFns } from "./MobileProxy.vue?vue&type=template&id=42d820a2&"
import script from "./MobileProxy.vue?vue&type=script&lang=js&"
export * from "./MobileProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d820a2')) {
      api.createRecord('42d820a2', component.options)
    } else {
      api.reload('42d820a2', component.options)
    }
    module.hot.accept("./MobileProxy.vue?vue&type=template&id=42d820a2&", function () {
      api.rerender('42d820a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MobileProxy.vue"
export default component.exports